module.exports = __webpack_public_path__ + "img/edge_activites_livre.fe212638.svg";